/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NumericData } from '../models/NumericData';
import type { RoutesCollectionVolumeResponse } from '../models/RoutesCollectionVolumeResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MarketDataService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get floor price of a collection
     * Returns collection floor price
     * @returns NumericData OK
     * @throws ApiError
     */
    public getCollectionFloorPrice({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
    }): CancelablePromise<NumericData> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/{address}/market-data/floor-price',
            path: {
                'address': address,
                'network': network,
            },
            errors: {
                400: `Validation Error`,
                403: `Access not enabled`,
            },
        });
    }

    /**
     * Get market cap of a collection
     * Returns collection market cap
     * @returns NumericData OK
     * @throws ApiError
     */
    public getCollectionMarketCap({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
    }): CancelablePromise<NumericData> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/{address}/market-data/market-cap',
            path: {
                'address': address,
                'network': network,
            },
            errors: {
                400: `Validation Error`,
                403: `Access not enabled`,
            },
        });
    }

    /**
     * Get volume of a collection
     * Returns collection volume
     * @returns RoutesCollectionVolumeResponse OK
     * @throws ApiError
     */
    public getCollectionVolume({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
    }): CancelablePromise<RoutesCollectionVolumeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/{address}/market-data/volume',
            path: {
                'address': address,
                'network': network,
            },
            errors: {
                400: `Validation Error`,
                403: `Access not enabled`,
            },
        });
    }

}